const INCREMENT_PROGRESS = "INCREMENT_PROGRESS"
const DECREMENT_PROGRESS = "DECREMENT_PROGRESS"
const INCREMENT_MIRROR_PROGRESS = "INCREMENT_MIRROR_PROGRESS"
const DECREMENT_MIRROR_PROGRESS = "DECREMENT_MIRROR_PROGRESS"
const SET_PROGRESS = "SET_PROGRESS"
const SET_NAME = "SET_NAME"
const SET_SECTION_LENGTH = "SET_SECTION_LENGTH"
const SET_CURRENT_SECTION = "SET_CURRENT_SECTION"
const SET_USER_AGE = "SET_USER_AGE"
const END_QUIZ_EARLY = "END_QUIZ_EARLY"
const START_INTERSTITIAL = "START_INTERSTITIAL"
const END_INTERSTITIAL = "END_INTERSTITIAL"
const SET_USER_TOKEN = "SET_USER_TOKEN"
const SET_QUESTION_ID = "SET_QUESTION_ID"
const SET_RESPONSE_COMPLETE = "SET_RESPONSE_COMPLETE"
const RES_COMPLETE = "RES_COMPLETE"
const DYNAMICALLY_SET_SECTION_LENGTH = "DYNAMICALLY_SET_SECTION_LENGTH"
const UNEND_QUIZ_EARLY = "UNEND_QUIZ_EARLY"
const INCREMENT_TOTAL_PROGRESS = "INCREMENT_TOTAL_PROGRESS"
const DECREMENT_TOTAL_PROGRESS = "DECREMENT_TOTAL_PROGRESS"
const SET_GLOBAL_PROGRESS = "SET_GLOBAL_PROGRESS"
const SET_TOTAL_QUESTIONS = "SET_TOTAL_QUESTIONS"
const TOGGLE_MOVING_FORWARD = "TOGGLE_MOVING_FORWARD"
const TRIGGER_GLOBAL_UNMOUNT = "TRIGGER_GLOBAL_UNMOUNT"
const REVEAL_OR_HIDE_PROGRESS = "REVEAL_OR_HIDE_PROGRESS"
const TOGGLE_NAME_GREETING = "TOGGLE_NAME_GREETING"
const SET_SHOW_BACK_BUTTON = "SET_SHOW_BACK_BUTTON"
const SET_QUIZ_MOUNTED = "SET_QUIZ_MOUNTED"
const SET_EMAIL_CAPTURE = "SET_EMAIL_CAPTURE"
const UPDATE_QUIZ_ANSWERS = "UPDATE_QUIZ_ANSWERS"
const SET_IS_MINOXIDIL = "SET_IS_MINOXIDIL"
const SET_IS_FINASTERIDE = "SET_IS_FINASTERIDE"
const SET_IS_NO_HAIR_HISTORY = "SET_IS_NO_HAIR_HISTORY"
const SET_IS_MHMD = "SET_IS_MHMD"
const SET_MHMD_STATE = "SET_MHMD_STATE"
const SET_MHMD_OPTED = "SET_MHMD_OPTED"
const SET_HEADER_VARIANT = "SET_HEADER_VARIANT"
const SET_LOCATION = "SET_LOCATION"
const SET_PRODUCT_RECO = "SET_PRODUCT_RECO"

export const incrementProgress = (newProgress) => {
  return {
    type: INCREMENT_PROGRESS,
    payload: newProgress,
  }
}

export const decrementProgress = (newProgress) => {
  return {
    type: DECREMENT_PROGRESS,
    payload: newProgress,
  }
}

export const setProgress = (newProgress) => {
  return {
    type: SET_PROGRESS,
    payload: newProgress,
  }
}

export const setName = (name) => {
  return {
    type: SET_NAME,
    payload: name,
  }
}

export const setSectionLength = (length) => {
  return {
    type: SET_SECTION_LENGTH,
    payload: length,
  }
}

export const setCurrentSection = (name = "") => {
  const payload = name.split('/').filter(Boolean).pop()
  return {
    type: SET_CURRENT_SECTION,
    payload
  }
}

export const setUserAge = (age) => {
  return {
    type: SET_USER_AGE,
    payload: age,
  }
}

export const endQuizEarly = () => {
  return {
    type: END_QUIZ_EARLY,
    payload: true,
  }
}

export const startInterstitial = () => {
  return {
    type: START_INTERSTITIAL,
    payload: true,
  }
}

export const endInterstitial = () => {
  return {
    type: END_INTERSTITIAL,
    payload: false,
  }
}

export const setUserToken = (token) => {
  return {
    type: SET_USER_TOKEN,
    payload: token,
  }
}

export const setQuestionId = (id) => {
  return {
    type: SET_QUESTION_ID,
    payload: id,
  }
}

export const setResponseComplete = () => {
  return {
    type: SET_RESPONSE_COMPLETE,
    payload: true,
  }
}

export const setResultsResponseComplete = () => {
  return {
    type: RES_COMPLETE,
    payload: true,
  }
}

export const dynamicallySetSectionLength = (section, length) => {
  return {
    type: DYNAMICALLY_SET_SECTION_LENGTH,
    payload: {
      section: section,
      length: length,
    },
  }
}

export const unendQuizEarly = () => {
  return {
    type: UNEND_QUIZ_EARLY,
  }
}

export const incrementTotalProgress = () => {
  return {
    type: INCREMENT_TOTAL_PROGRESS,
  }
}

export const decrementTotalProgress = () => {
  return {
    type: DECREMENT_TOTAL_PROGRESS,
  }
}

export const setGlobalProgress = (prog) => {
  return {
    type: SET_GLOBAL_PROGRESS,
    payload: prog,
  }
}

export const setTotalQuestions = (total) => {
  return {
    type: SET_TOTAL_QUESTIONS,
    payload: total,
  }
}

export const toggleMovingForward = (bool) => {
  return {
    type: TOGGLE_MOVING_FORWARD,
    payload: bool,
  }
}

export const triggerGlobalUnmount = (bool) => {
  return {
    type: TRIGGER_GLOBAL_UNMOUNT,
    payload: bool,
  }
}

export const revealOrHideProgress = (bool) => {
  return {
    type: REVEAL_OR_HIDE_PROGRESS,
    payload: bool,
  }
}

export const incrementMirrorProgress = (newProgress) => {
  return {
    type: INCREMENT_MIRROR_PROGRESS,
    payload: newProgress,
  }
}

export const decrementMirrorProgress = (newProgress) => {
  return {
    type: DECREMENT_MIRROR_PROGRESS,
    payload: newProgress,
  }
}

export const toggleNameGreeting = (bool) => {
  return {
    type: TOGGLE_NAME_GREETING,
    payload: bool,
  }
}

export const setShowBackBtn = (bool) => {
  return {
    type: SET_SHOW_BACK_BUTTON,
    payload: bool,
  }
}

export const setQuizMounted = (bool) => {
  return {
    type: SET_QUIZ_MOUNTED,
    payload: bool,
  }
}

export const setEmailCapture = (bool) => {
  return {
    type: SET_EMAIL_CAPTURE,
    payload: bool,
  }
}

export const updateQuizAnswers = (answersObj) => {
  return {
    type: UPDATE_QUIZ_ANSWERS,
    payload: answersObj,
  }
}

export const setIsFinasteride = (bool) => {
  return {
    type: SET_IS_FINASTERIDE,
    payload: bool,
  }
}

export const setIsMinoxidil = (bool) => {
  return {
    type: SET_IS_MINOXIDIL,
    payload: bool,
  }
}

export const setIsNoHairHistory = (bool) => {
  return {
    type: SET_IS_NO_HAIR_HISTORY,
    payload: bool,
  }
}

export const setIsMhmd = (bool) => {
  return {
    type: SET_IS_MHMD,
    payload: bool,
  }
}

export const setMhmdState = (location) => {
  return {
    type: SET_MHMD_STATE,
    payload: location,
  }
}

export const setMhmdOpted = (bool) => {
  return {
    type: SET_MHMD_OPTED,
    payload: bool,
  }
}

export const setHeaderVariant = (bool) => {
  return {
    type: SET_HEADER_VARIANT,
    payload: bool,
  }
}

export const setLocation = (location) => {
  return {
    type: SET_LOCATION,
    payload: location,
  }
}

export const setProductReco = (productReco) => {
  return {
    type: SET_PRODUCT_RECO,
    payload: productReco,
  }
}
